import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { MongoDbLinkedService } from 'app/model/linkedservice/mongo-db.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'MongoDbCollection',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.MongoDb_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.MongoDb_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MongoDbLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MongoDbDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
